import Vue from 'vue'
import Router from 'vue-router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import inviteLogin from '@/components/pages/inviteLogin/inviteLogin'
import inviteLoginSZ from '@/components/pages/inviteLoginSZ/inviteLogin'
import inviteLoginST from '@/components/pages/inviteLoginST/inviteLogin'
import changePswd from '../components/pages/changePswd/changePswd.vue'

// 全局修改默认配置，点击空白处不能关闭弹窗
ElementUI.Dialog.props.closeOnClickModal.default = false
Vue.use(Router).use(ElementUI)

export default new Router({
    routes: [{
        path: '/inviteLogin',
        name: 'inviteLogin',
        component: inviteLogin,
        meta: {
            requireAuth: '' // 不需要鉴权
        }
    },
    {
        path: '/inviteLoginSZ',
        name: 'inviteLoginSZ',
        component: inviteLoginSZ,
        meta: {
            requireAuth: '' // 不需要鉴权
        }
    },
            {
                path: '/inviteLoginST',
                name: 'inviteLoginST',
                component: inviteLoginST,
                meta: {
                        requireAuth: '' // 不需要鉴权
                }
        },
        {
            path: '/changePswd',
            name: 'changePswd',
            component: changePswd,
            meta: {
                    requireAuth: '' // 不需要鉴权
            }
    },
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js